import type {
    ConsulterEligibiliteSimulationModesLivraison200Response,
    ConsulterEligibiliteSimulationModesLivraisonBodyRequest,
} from '@bytel/pt-ihm-api-portailvente-pev-eligibilite';

import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

import { PevMapper } from '@mappers/pev';

import { DeliveryContextType, DeliveryModesType } from '@app-types/product-delivery';

import { PEV_X_VERSION } from '@constants/api';

const appConfig = getAppConfig();

export const DEFAULT_DELIVERY_ADDRESS = {
    codePostal: '75000',
    ville: 'PARIS',
    pays: 'FRANCE',
};

export class DeliveryRepository {
    url: string;

    public constructor(url: string) {
        this.url = url;
    }

    public async getSimulatedDeliveryModes(
        gencode: string,
        context: DeliveryContextType = {},
    ): Promise<DeliveryModesType> {
        const { user, idPu, address, contractId } = context;

        const body: ConsulterEligibiliteSimulationModesLivraisonBodyRequest = {
            parcours: [
                {
                    type: contractId ? 'RENOUVELLEMENT' : 'ACQUISITION',
                    referenceExterne: 'referenceExterne-parcours',
                    elements: [
                        {
                            composantCommercial: { identifiant: gencode },
                            referenceExterne: 'referenceExterne-gencodeTel',
                        },
                    ],
                    ...(contractId && { contrat: { identifiant: contractId } }),
                },
            ],
            acheteur: idPu ? { type: 'PERSONNE', noPersonne: idPu } : { type: 'NON_CONNU_GP' },
            adresseLivraison: {
                codePostal: address?.zipCode ?? DEFAULT_DELIVERY_ADDRESS.codePostal,
                ville: address?.city ?? DEFAULT_DELIVERY_ADDRESS.ville,
                pays: DEFAULT_DELIVERY_ADDRESS.pays,
            },
        };

        return apiHttpService
            .post<
                ConsulterEligibiliteSimulationModesLivraison200Response,
                ConsulterEligibiliteSimulationModesLivraisonBodyRequest
            >(`${this.url}/paniers/simulation-modes-livraison-eligibles`, body, {
                headers: { 'x-version': PEV_X_VERSION.V5 },
                ttl: Number.parseInt(appConfig.cache.ttl.products),
                tags: [CACHE_TAGS.PRODUCT_DETAIL],
                user: idPu ? user : undefined,
            })
            .then(PevMapper.mapToDeliveryModes)
            .catch(() => []);
    }
}

export const deliveryRepository = new DeliveryRepository(appConfig.b2r.url);
